module.exports = __webpack_public_path__ + "img/Feature.2a925b94.jpg";